import React, { useContext, useState } from 'react';
import { globalObject } from '@skbkontur/global-object';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { useLocaleForControl } from "../../../lib/locale/useLocaleForControl";
import { CrossIcon } from "../../../internal/icons/CrossIcon";
import { cx } from "../../../lib/theming/Emotion";
import { keyListener } from "../../../lib/events/keyListener";
import { styles } from "../SidePage.styles";
import { SidePageLocaleHelper } from "../locale";
import { SidePageHeaderDataTids } from "../SidePageHeader";
import { SidePageContext } from "../SidePageContext";
export var SidePageCloseButton = function SidePageCloseButton() {
  var _cx;

  var _useState = useState(false),
      isFocusedByTab = _useState[0],
      setIsFocusedByTab = _useState[1];

  var locale = useLocaleForControl('SidePage', SidePageLocaleHelper);
  var theme = useContext(ThemeContext);
  var sidePageContext = useContext(SidePageContext);

  var handleFocus = function handleFocus() {
    globalObject.requestAnimationFrame == null ? void 0 : globalObject.requestAnimationFrame(function () {
      if (keyListener.isTabPressed) {
        setIsFocusedByTab(true);
      }
    });
  };

  var handleBlur = function handleBlur() {
    setIsFocusedByTab(false);
  };

  return /*#__PURE__*/React.createElement("button", {
    "aria-label": locale == null ? void 0 : locale.closeButtonAriaLabel,
    className: cx(styles.close(theme), (_cx = {}, _cx[styles.closeFocus(theme)] = isFocusedByTab, _cx)),
    onFocus: handleFocus,
    onBlur: handleBlur,
    onClick: sidePageContext.requestClose,
    "data-tid": SidePageHeaderDataTids.close
  }, /*#__PURE__*/React.createElement(CrossIcon, null));
};
SidePageCloseButton.__KONTUR_REACT_UI__ = 'SidePageCloseButton';
SidePageCloseButton.displayName = 'SidePageCloseButton';